'use client'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { reloadPage } from '@marketplace-web/shared/browser-util'
import {
  updateShippingDeadlineExtension,
  clickEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { ResponseCode } from '@marketplace-web/core-api/api-client-util'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import { DeadlineExtensionStatus } from '../../constants'

type Props = ConversationActionProps

const DeclineShippingDeadlineExtension = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id
  const shipmentId = conversation?.transaction?.shipment?.id

  const trackButtonClick = () => {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'decline_shipping_deadline_extension',
        screen: 'message_reply',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  async function declineExtendShippingDeadline() {
    if (!shipmentId) return

    const response = await updateShippingDeadlineExtension({
      shipmentId,
      status: DeadlineExtensionStatus.Cancelled,
    })

    if (response.code === ResponseCode.Ok) reloadPage()
  }

  const handleClick = () => {
    trackButtonClick()

    declineExtendShippingDeadline()
  }

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
      testId="decline-shipping-deadline-extension-conversation-action"
    />
  )
}

export default DeclineShippingDeadlineExtension
